// packages/compose/src/hooks/use-reduced-motion/index.js
import useMediaQuery from "../use-media-query/index.mjs";
var useReducedMotion = () => useMediaQuery("(prefers-reduced-motion: reduce)");
var use_reduced_motion_default = useReducedMotion;
export {
  use_reduced_motion_default as default
};
//# sourceMappingURL=index.mjs.map
